import type { Module } from 'vuex';
import { PriceExchange } from '@/types/PriceExchange';
import {RootState} from "@/store";

export interface PriceExchangesState {
  priceExchanges: PriceExchange[];
}

const priceExchangesModule: Module<PriceExchangesState, RootState> = {
  namespaced: true,

  state: (): PriceExchangesState => ({
    priceExchanges: [],
  }),

  getters: {
    getById: (state) => (indexExchange: number): PriceExchange | undefined => {
      return state.priceExchanges.find(exchange => exchange.indexExchange === indexExchange);
    },
    getByCode: (state) => (code: string): PriceExchange | undefined => {
      return state.priceExchanges.find(exchange => exchange.code === code);
    },
  },

  mutations: {
    setPriceExchanges(
      state,
      payload: { priceExchanges: Record<number, any> }
    ) {
      state.priceExchanges = Object
        .values(payload.priceExchanges)
        .map(raw => PriceExchange.fromRaw(raw));
    },

    setPriceExchangeCreate(
      state,
      payload: {
        indexExchange: number;
        code: string;
      }
    ) {
      state.priceExchanges.push(new PriceExchange(
        payload.indexExchange,
        payload.code,
      ));
    },

  },

  actions: {
    wsSetPriceExchanges({ commit }, payload) {
      commit('setPriceExchanges', payload);
    },
    wsPriceExchangeCreate({ commit }, payload) {
      commit('setPriceExchangeCreate', payload);
    },
  },
};

export default priceExchangesModule;
